import { render, staticRenderFns } from "./activeChatDropdownAssign.vue?vue&type=template&id=db301650&"
import script from "./activeChatDropdownAssign.vue?vue&type=script&lang=js&"
export * from "./activeChatDropdownAssign.vue?vue&type=script&lang=js&"
import style0 from "./activeChatDropdownAssign.vue?vue&type=style&index=0&id=db301650&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports